import { 
    useState,
    useEffect,
    useContext,
    useRef,
} from 'react';
import {Link, useHistory} from 'react-router-dom';
import "./Header.css";
import logo from './logo.jpeg';
import {
    Stack,
    Button,
    Avatar,
    useMediaQuery,
    Tooltip,
    IconButton
} from '@mui/material';
import UserContext from '../../context/user';
import LanguageSwitcher from './components/LanguageSwitcher';
import { Language, HelpOutline } from '@mui/icons-material';
import HeaderMenu from './components/HeaderMenu';
import PopUpMsg from '../merge-profile/popUpMsg'
import popUpMessages from '../../config/popUpMsg.json';
import TaskIcon from '@mui/icons-material/Task';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import BulkOperationsModal from '../bulk-search/BulkOperationsModal';


/**
 * @param {boolean} noUser - When true, header will not show user credentials. It will show content for non-authenticated
 * users.
 */
export default function Header({noUser,}) {

    const [openNavbarDropdown, setOpenNavbarDropdown] = useState(false);
    const UserInfo = useContext(UserContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openHeaderDialog, setOpenHeaderDialog] = useState(false);
    const [name, setName] = useState('?');
    const [splittedUsername, setSplittedUsername] = useState(UserInfo.user_name);
    const [openLanguageDialog, setOpenLanguageDialog] = useState(false);
    const [popMsg] = useState(popUpMessages.raiseAccess)
    const [popUpMessage, setPopUpMessage] = useState({ heading: '', message: '' })
    const [showPopup, setShowPopUp] = useState(false)
    const [showBulkOperations, setShowBulkOperations] = useState(false);

    //This could be possibly moved.
    const helpURL = 'https://collab.lilly.com/:p:/r/sites/GCOTraining/_layouts/15/Doc.aspx?sourcedoc=%7BD722C4CD-A195-4EE9-9AE4-F8BBFBF9BBB1%7D&file=Enterprise%20Customer%20Search%20(ECS)%20User%20Guide.pptx&action=edit&mobileredirect=true';

    const isSmallScreen = useMediaQuery('(max-width: 825px)');
    let clickRef = useRef(null);
    let btnRef = useRef(null);
    const currentURL = window.location.href;
    const history = useHistory();
    //listen for clicks away from element
    useEffect(()=> {
        document.addEventListener('mousedown',clickAwayListener);
        return ()=> document.removeEventListener('mousedown',clickAwayListener);
    },[]);

    useEffect(()=> {
        try {
            let nameArray = (UserInfo && UserInfo.user_name) ? UserInfo.user_name.split(' - ')[0].split(' ') : [];
            setName(noUser === undefined ? nameArray[0].match(/[A-Z]/)[0] + '' + nameArray[nameArray.length - 1].match(/[A-Z]/)[0] : '?')
            setSplittedUsername(splittedUsername.split(' - ')[0])
        } catch(error) {
            setName('?');
        }
    },[noUser,UserInfo]);

    const renderHTML = (html) => ({ __html: html });

    function clickAwayListener(e) {
        if(
            clickRef.current && 
            !clickRef.current.contains(e.target) && 
            !btnRef.current.contains(e.target)
        ){
            setOpenNavbarDropdown(false);
        }
    }


    function onRefreshPage() {
        window.location.href='/';
    }

    function handleMenuToggle(e){
        setAnchorEl(e.target);
    }

    function handleDropdownClick(location){
        setOpenNavbarDropdown(false);
        history.push(location);
    }

    function onOpenLanguageMenu() {
        setOpenLanguageDialog(true);
        setOpenNavbarDropdown(false);
    }

    function onCloseHeaderMenu() {
        setOpenHeaderDialog(false);
        setAnchorEl(null);
    }

    function onOpenHeaderDialog(){
        setOpenHeaderDialog(true);
        setOpenNavbarDropdown(false);
    }

    const showRaiseAccessPopUp = () =>{
        setPopUpMessage({ heading: popMsg[0].raiseAccess.heading, message: <div dangerouslySetInnerHTML={renderHTML(popMsg[0].raiseAccess.description)}/>, onOk: 'Confirm' })
        setOpenNavbarDropdown(false)
        setShowPopUp(true)
    }

    const onOK = () => {
        setPopUpMessage({heading: '', message: '' })
        setShowPopUp(false)
    }

    return (
        <>
            <HeaderMenu
                UserInfo={UserInfo}
                splittedUsername={splittedUsername}
                name={name}
                anchorEl={isSmallScreen?null:anchorEl}
                closeComponent={onCloseHeaderMenu}
                openHeaderDialog={openHeaderDialog}
            />
             {showBulkOperations &&
                <BulkOperationsModal
                    open={showBulkOperations}
                    onClose={()=> setShowBulkOperations(false)}
                />
            }
            <nav className='header-nav-container'>
                <Stack
                    direction={'row'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    width={'100%'}
                    sx={{paddingBottom:'10px'}}
                >

                    <Link to='#' onClick={onRefreshPage}>
                        <img 
                            src={logo} 
                            alt="logo" 
                            className="header-logo"
                        />
                    </Link>
                    
                    <h2 style={{fontSize:'1.4rem', margin:0}} className="large-nav-item nav-link text-center text-danger" id="header-text" >Enterprise Customer Search {currentURL.split('/')[3] == 'ecs-inbox' && <>| <TaskIcon fontSize="large" /> Inbox</>}</h2>
                    <Stack 
                        gap={1}
                        direction={'row'} 
                        justifyContent={'flex-end'} 
                        alignItems={'center'}
                        className='large-nav-item'
                    >
                        <Tooltip 
                            PopperProps={{style:{zIndex:9001}}}
                            title={<span className='_wg-exclude'>Bulk Operations</span>}
                        >
                            <IconButton
                                disableRipple
                                onClick={()=>setShowBulkOperations(true)}
                            >
                                <AutoAwesomeMosaicIcon
                                    sx={{cursor:'pointer'}}
                                    style={{color: '#d32f2f'}}
                                />
                            </IconButton>
                        </Tooltip>
                        {
                            noUser !== true && (
                                <Tooltip 
                                        PopperProps={{style:{zIndex:9001}}}
                                        title={<span className='_wg-dynamic-text'>Help</span>}
                                    >
                                        <IconButton 
                                            disableRipple 
                                            onClick={()=> window.open(helpURL,'_blank')}
                                        >
                                            <HelpOutline style={{color: 'var(--lilly-primary)', cursor:'pointer'}}/>
                                        </IconButton>
                                </Tooltip>
                            )
                       }
                        <Tooltip 
                            PopperProps={{style:{zIndex:9001}}}
                            title={<span className='_wg-exclude'>Choose Language</span>}
                        >
                            <IconButton
                                disableRipple
                            >
                                <Language
                                    sx={{cursor:'pointer'}}
                                    style={{color: '#d32f2f'}}
                                />
                            </IconButton>
                        </Tooltip>
                        <LanguageSwitcher
                            isDialog={isSmallScreen}
                            openDialog={openLanguageDialog}
                            onCloseDialog={()=>setOpenLanguageDialog(false)}
                        />
                        {
                            noUser !== true && (
                            <Button aria-controls='fade-menu' aria-haspopup='true' onClick={handleMenuToggle}>
                                <Avatar className='bg-danger pointer'>
                                    {name}
                                </Avatar>
                            </Button>
                            )
                        }
                    </Stack>
                <div 
                    ref={btnRef}
                    onClick={()=>setOpenNavbarDropdown(!openNavbarDropdown)}
                    className={`header-hamburger`}>
                    <div className="header-hamburger-patty"></div>
                </div>
                </Stack>

                <div ref={clickRef} className="header-small-wrapper">
                    <div className={`header-small-expandable ${openNavbarDropdown===true?'header-expandable-toggled':''}`}>
                        <div className="header-small-content">
                            { UserInfo.isUserApprover &&
                            <div onClick={()=>handleDropdownClick('/ecs-inbox')} className="header-small-item _wg-dynamic-text" component='div'>
                                <p>ECS Inbox</p>
                            </div>
                            }
                            <div onClick={()=>handleDropdownClick('/track-request')} className="header-small-item _wg-dynamic-text" component='div'>
                                <p>DCR Status</p>
                            </div>

                            <div onClick={showRaiseAccessPopUp} className="header-small-item _wg-dynamic-text" component='div'>
                                <p>Access Request</p>
                            </div>

                            <div onClick={onOpenLanguageMenu} className="header-small-item _wg-exclude">
                                <p>Choose Language</p>
                            </div>
                            {
                                noUser !== true && (
                                    <>
                                        <div onClick={onOpenHeaderDialog} className="header-small-item _wg-dynamic-text">
                                            <p>Profile Details</p>
                                        </div>
                                        <div 
                                            className='header-small-item _wg-dynamic-text' 
                                            onClick={()=> window.open(helpURL,'_blank')} >
                                            <p>Help</p>
                                        </div>
                                    </>
                                )
                            }
                            
                        </div>
                    </div>
                </div>
            </nav>

            {showPopup &&
                <PopUpMsg
                popUpMessage={popUpMessage}
                onOK={() => onOK()}
                />
            }
        </>
    );
}